import type { StatefulDiaryT } from "../../../types/database/diaries";
import type { StatefulObservationViewT } from "../../../types/database/observations";
import { useDiaryByIdQuery } from "../../diaries/api";

export function extractObservationById(
	diary: StatefulDiaryT,
	observationId: string,
) {
	return diary?.observations_view?.find(
		(m) => m.observation_id === observationId,
	) as StatefulObservationViewT;
}

const useExtractObservation = (
	diaryId: string,
	observationId: string,
): StatefulObservationViewT => {
	const { data: diary } = useDiaryByIdQuery(diaryId);

	return extractObservationById(
		diary as StatefulDiaryT,
		observationId,
	) as StatefulObservationViewT;
};

export default useExtractObservation;
